<div class="app-shell" [class.app-shell--with-header]="showHeader()">
  @if (showHeader()) {
    <div class="app-shell__header">
      <ui-app-header
        variant="portal"
        logoSrc="/images/logo_azul.png"
        logoAlt="System DYG"
        [navTitle]="title()"
        [showMenuToggle]="false"
        [showNotification]="false"
      />
    </div>
  }

  <router-outlet />

  <ui-whatsapp-fab [href]="whatsappSupportHref" />
</div>
